// extracted by mini-css-extract-plugin
module.exports = {"icon":"_45e77c2","xs":"_ac2f7b3","sm":"_646fb7b","lg":"_23bb769","xl":"_d561c49","x1":"_1182cfd","x2":"_b9728c1","x25":"_082a6ea","x3":"_cd7a10b","x4":"_d152234","x5":"_5476617"};